












import { Component, Vue, Ref } from 'vue-property-decorator';
import superAdminGuard from '@/guards/super-admin-guard';
import MainPaycheckLineTemplateForm from '@/components/MainPaycheckLineTemplate/MainPaycheckLineTemplateForm.vue';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';

@Component({
  components: {
    MainPaycheckLineTemplateForm,
  },
  beforeRouteEnter(to, from, next) {
    superAdminGuard(to, from, next).catch(router => {
      router.push({ name: 'Dashboard' });
      router.app.$sMessage.error(router.app.$t('MainPaycheckLineTemplate.noPermissions'));
    });
  },
})
export default class ApplicationSettings extends Vue {
  @Ref('mainPaycheckLineTemplateForm') private readonly form!: MainPaycheckLineTemplateForm;

  @UnsavedChanges<ApplicationSettings>({
    messages: {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      entity: i18n.t('MainPaycheckLineTemplate.mainPaycheckTemplates'),
    },
    saveAndContinue() {
      return this.form && this.form.saveAndContinue();
    },
  }) private dirtyForm = false;
}
